import React, { useEffect, useState } from 'react';

export function useIsInViewport(ref: React.RefObject<HTMLDivElement>) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      // set isIntersecting based on the most _recent_ IntersectionObserverEntry
      const latestEntry = entries[entries.length - 1];
      setIsIntersecting(latestEntry.isIntersecting);
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return isIntersecting;
}

export function useHasBeenInViewport(ref: React.RefObject<HTMLDivElement>) {
  const [hasIntersected, setHasIntersected] = useState(false);
  const isInViewport = useIsInViewport(ref);

  useEffect(() => {
    if (!hasIntersected && isInViewport) {
      setHasIntersected(true);
    }
  }, [hasIntersected, isInViewport]);

  return hasIntersected;
}
